export const loaderStatus = {
  NOT_INITIATED: 'NOT_INITIATED',
  READY: 'READY',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETE: 'COMPLETE',
  ERROR_NOT_LOADABLE: 'ERROR_NOT_LOADABLE',
};
